import React from 'react';
import FeaturedCard from './components/FeaturedCard';

function App() {
  return (
    <div className="container mx-auto px-14 sm:px-6 py-8 max-w-2xl">
      <header className="text-center mb-8">
        <div className="profile mb-4">
          <img src="/profile-pic.png" alt="Profile Icon" className="w-40 h-40 rounded-full object-cover object-center-top p-1 shadow-md mx-auto" />
        </div>
        <h1 className="text-5xl font-bold mb-2">itsjustinjapan</h1>
        <p className="text-lg text-gray-600">Your Japan Travel Guide. Inspo, guides and insider tips.</p>
      </header>
      <main>
        <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Featured 🔥</h2>
        <FeaturedCard
          title="14-day Japan Travel Planner"
          description="Skip weeks of planning with our customizable itinerary."
          imageUrl="/card-image-1.png"
          buttonText="Shop Now"
          link="https://itsjustinjapan.etsy.com/listing/1614929414"
          useRainbowButton={true}  // Changed from useShimmerButton to useRainbowButton
        />
      </section>
        {/* <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Experiences 🚀</h2>
          <FeaturedCard
            title="First time in Japan? Ultimate half-day in Tokyo"
            description="Experience designed by me, delivered by local hosts"
            imageUrl="/card-image-2.JPEG"
            buttonText="Join Now"
            link="https://www.cityunscripted.com/japan/tokyo-tours/itsjustinjapan-ultimate-half-day-in-tokyo?utm_source=Crea%20tor_program_engagement_test&utm_medium=social_Instagram&utm_campaign=Justin_Poon&utm_term=20%20240402&utm_content=size_50k-100k"
          />
        </section> */}
        {/* <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Travel Tips</h2>
        <SmallerCard
          icon={Ticket}
          title="Klook Value Travel Pass"
          description="Don't get the JR pass.  Get this instead."
          ctaText="More info"
          primaryColor="#0a2f1f"
          link="https://www.klook.com/..."
        />
      </section> */}
      </main>
    </div>
  );
}

export default App;